// Site-Header.js

var $ = require('jquery');

var firstFocusItem;
var lastFocusItem;

$(document).ready(function() {
    document.querySelector(':root').style.setProperty('--header-height', $('.site-header').outerHeight(true) + 'px');

    // Accessible Menu
    // https://theadminbar.com/accessibility-weekly/mobile-nav-and-hamburger-menus/
    // https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/
    // https://codepen.io/amberhinds/pen/gOBpBBo
    // https://www.toptal.com/developers/keycode

    var body = $('body');
    var menu = $('.site-header__mobile');
    var toggleButton = $('.site-header .header__toggle');
    
    toggleButton.attr('aria-expanded', false);

    // Open menu
    toggleButton.on('click', function(){
        $(this).toggleClass('is-active');

        body.toggleClass("-has-nav");

        toggleMenu(menu, $(this).hasClass('is-active') ? true : false);

        if ( $(this).hasClass('is-active') ) {
            $(this).attr('aria-expanded', true);
            menu.on('keydown', trapFocus);

            // All focusable items
            var focusItem = menu.find("a, button, input, select, textarea");
            firstFocusItem = focusItem[0];
            lastFocusItem = focusItem[focusItem.length - 1];

            // Shift focus
            var navigation = menu.find('.content__primary');
            var firstLink = navigation.find('a').first();
            if(firstLink.length != 0) { $(firstLink).trigger("focus"); } 
            else { toggleButton.trigger("focus"); }

        } else {
            $(this).attr('aria-expanded', false);
            toggleButton.attr('aria-expanded', false);

            menu.off('keydown', trapFocus);
            toggleButton.trigger("focus"); 
        } 
    });

    $(window).on("scroll", function() {
        var start = ($("body").hasClass("home")) ? $(".page-section--hero").height() : 50;
        var isSticky = ($(this).scrollTop() > start);
        $('.site-header').toggleClass("--is-sticky", isSticky );
    }).trigger("scroll");
})


// - - - FUNCTION - - -


function trapFocus(event) {
    if(event.keyCode == 9) {
        
        if(event.shiftKey) {
            if(document.activeElement == firstFocusItem) {
                event.preventDefault();
                $(lastFocusItem).trigger("focus");
            }
        } else {
            if(document.activeElement == lastFocusItem) {
                event.preventDefault();
                $(firstFocusItem).trigger("focus");
            }
        }
    }
    if(event.keyCode == 27) {
        toggleButton.trigger( "click" );
    }
}

function toggleMenu(menu, open) { 
    menu.show();
    
    if (open) { 
        menu.animate({ 'right': 0 }, 900, function() {
            menu.show();
        });

    } else { 
        menu.animate({ 'right': '-100%' }, 900, function() {
            menu.hide();
        });
    }  
}